//公共js，主要做表单验证，以及基本方法封装
const utils = {
    isNullOrEmpty: function (value) {
        //是否为空
        return (value === null || value === '' || value === undefined) ? true : false;
    },
    trim: function (value) {
        //去空格
        return value.replace(/(^\s*)|(\s*$)/g, "");
    },
    isMobile: function (value) {
        //是否为手机号
        return /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/
            .test(value);
    },
    isFloat: function (value) {
        //金额，只允许保留两位小数
        return /^([0-9]*[.]?[0-9])[0-9]{0,1}$/.test(value);
    },
    isNum: function (value) {
        //是否全为数字
        return /^[0-9]+$/.test(value);
    },
    isName: function (value) {
        // 是否为汉字
        return /^[\u4E00-\u9FA5A-Za-z]+$/.test(value);
    },
    checkPwd: function (value) {
        //密码为8~20位数字和字母组合
        return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(value);
    },
    formatNum: function (num) {
        //格式化手机号码
        if (utils.isMobile(num)) {
            num = num.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
        }
        return num;
    },
    checkPassword : function (newPassword) {
        let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
        return reg.test(newPassword);
    },
    //是否包含特殊字符
    isSpecialChar: function (value) {
        let reg = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im;
        return reg.test(value);
    },
    //资料校验
    checkData: function (frmCompany) {
        if (frmCompany.enterpriseAbbreviation==='') {
            return "请输入公司简称"
        }
        //长度校验（30）
        if(frmCompany.enterpriseAbbreviation.length>30){
            return "公司简称长度不能超过30个字符"
        }

        if(this.isSpecialChar(frmCompany.enterpriseAbbreviation)){
            return '公司简称不能包含特殊字符'
        }

        if(frmCompany.businessLicenseNumber===''){
            return '请输入统一社会信用代码'
        }
        utils.isBusinessLicenseNumber = function (businessLicenseNumber) {
            let reg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;
            return reg.test(businessLicenseNumber);
        }

        //营业执照注册号18位阿拉伯数字或大写英文字母
        if(!utils.isBusinessLicenseNumber(frmCompany.businessLicenseNumber)){
            return '统一社会信用代码格式不正确'
        }

        if(frmCompany.address===''){
            return '请输入公司地址'
        }

        if(frmCompany.address.length>100){
            return '公司地址长度不能超过100个字符'
        }

        if(frmCompany.legalRepresentativeName===''){
            return '请输入法人姓名'
        }
        //长度校验（30）
        if(frmCompany.legalRepresentativeName.length>30){
            return "法人姓名长度不能超过30个字符"
        }
        //是否包含特殊字符
        if(this.isSpecialChar(frmCompany.legalRepresentativeName)){
            return '法人姓名不能包含特殊字符'
        }
        if(frmCompany.contactNumber===''){
            return '请输入法人电话'
        }
        //法人电话
        if(!utils.isMobile(frmCompany.contactNumber)){
            return '法人电话格式不正确'
        }
        if(frmCompany.enterpriseContact===''){
            return '请输入联系人姓名'
        }
        //长度（30）、特殊字符（不许出现）
        if(frmCompany.enterpriseContact.length>30){
            return '联系人姓名长度不能超过30个字符'
        }
        if(!utils.isName(frmCompany.enterpriseContact)){
            return '联系人姓名不能包含特殊字符'
        }
        if(frmCompany.enterpriseContactNumber===''){
           return '请输入联系人电话'
        }
        //联系人电话
        if(!utils.isMobile(frmCompany.enterpriseContactNumber)){
            return '联系人电话格式不正确'
        }
        return "success"
    },
    rmoney: function (money) {
        //金额格式化
        return parseFloat(money).toFixed(2).toString().split('').reverse().join('').replace(/(\d{3})/g, '$1,')
            .replace(
                /\,$/, '').split('').reverse().join('');
    },
    //身份证号码验证
    isCardNo: function (card) {
        let pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        return pattern.test(card);
    },
    //大于0小于100的数字
    isNum100: function (value) {
        return /^([1-9][0-9]?|100)$/.test(value);
    },
    rAge: function (birth) {
        let dBirth = new Date(birth)
        let dNowDate = new Date()
        let tampBirth = Date.parse(dBirth)
        let tampNow = Date.parse(dNowDate)
        let dayDiff = Math.ceil((tampNow - tampBirth) / (60 * 60 * 1000 * 24))
        let age = ''
        let yAge = Math.floor(dayDiff / 365)
        let yMod = dayDiff % 365
        let mMod = Math.floor(yMod / 30)
        let dMod = Math.floor(dayDiff % 365 % 30)
        // age = `${yAge}岁${mMod}月${dMod}天`
        age = `${yAge}岁`
        return age
    },
    formatDate: function (formatStr, fdate) {
        //日期格式化
        if (fdate) {
            if (~fdate.indexOf('.')) {
                fdate = fdate.substring(0, fdate.indexOf('.'));
            }
            fdate = fdate.toString().replace('T', ' ').replace(/\-/g, '/');
            var fTime, fStr = 'ymdhis';
            if (!formatStr)
                formatStr = "y-m-d h:i:s";
            if (fdate)
                fTime = new Date(fdate);
            else
                fTime = new Date();
            var month = fTime.getMonth() + 1;
            var day = fTime.getDate();
            var hours = fTime.getHours();
            var minu = fTime.getMinutes();
            var second = fTime.getSeconds();
            month = month < 10 ? '0' + month : month;
            day = day < 10 ? '0' + day : day;
            hours = hours < 10 ? ('0' + hours) : hours;
            minu = minu < 10 ? '0' + minu : minu;
            second = second < 10 ? '0' + second : second;
            var formatArr = [
                fTime.getFullYear().toString(),
                month.toString(),
                day.toString(),
                hours.toString(),
                minu.toString(),
                second.toString()
            ]
            for (var i = 0; i < formatArr.length; i++) {
                formatStr = formatStr.replace(fStr.charAt(i), formatArr[i]);
            }
            return formatStr;
        } else {
            return "";
        }
    },
    tampToDate: function (tamp, formatStr = 'Y-M-D h:m:s') {
        var date
        tamp.toString().length == 10 ? date = new Date(Number(tamp) * 1000) : date = new Date(
            Number(tamp)); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear();
        var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var D = date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate();
        var h = date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours();
        var m = date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes();
        var s = date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds();
        switch (formatStr) {
            case 'Y':
                return `${Y}`
                break
            case 'Y-M':
                return `${Y}-${M}`
                break
            case 'Y.M':
                return `${Y}.${M}`
                break
            case 'Y-M-D':
                return `${Y}-${M}-${D}`
                break
            case 'Y-M-D h:m':
                return `${Y}-${M}-${D} ${h}:${m}`
                break
            default:
                return `${Y}-${M}-${D} ${h}:${m}:${s}`
        }
    },

}

export default {
    isNullOrEmpty: utils.isNullOrEmpty,
    trim: utils.trim,
    isMobile: utils.isMobile,
    isFloat: utils.isFloat,
    isNum: utils.isNum,
    isNum100: utils.isNum100,
    isCardNo: utils.isCardNo,
    isName: utils.isName,
    checkPwd: utils.checkPwd,
    formatNum: utils.formatNum,
    rmoney: utils.rmoney,
    formatDate: utils.formatDate,
    tampToDate: utils.tampToDate,
    rAge: utils.rAge,
    isSpecialChar: utils.isSpecialChar,
    checkData: utils.checkData,
    checkPassword: utils.checkPassword,
}
